import React, { useContext, useState } from "react";
import AuthContext from "../../Contexts/Autenticacion/authContext";
import GastosContext from "../../Contexts/Gastos/gastosContext";
import { GASTO_URGENTE, GASTO_SIMPLE, GASTO_AVISO } from "../../types";

const CardGasto = ({ gasto }) => {
  const { autenticado, usuario } = useContext(AuthContext);
  const { eliminarGasto, seleccionarGasto } = useContext(GastosContext);

  const [state, setstate] = useState({
    animacion: null,
  });

  let bggasto = "bg-secondary";
  if (gasto.type === GASTO_URGENTE) {
    bggasto = "bg-danger";
  }
  if (gasto.type === GASTO_SIMPLE) {
    bggasto = "bg-dark";
  }
  if (gasto.type === GASTO_AVISO) {
    bggasto = "bg-warning";
  }

  const onClickEliminar = () => {
    eliminarGasto(gasto._id);

    if (state.animacion) {
      setstate({ animacion: null });
      return;
    }
    setstate({ animacion: "minimize" });
  };

  return (
    <div
      className={`card col col-5 col-md-3 p-0 m-1 text-white card-gasto    shadow ${bggasto} ${state.animacion}`}
    >
      <div className="card-header">
        <p className=" m-0 lead text-small  ">{gasto.username}</p>
      </div>
      <div className="card-body m-0 p-2 text-center">
        <p className="card-text">
          <span className="p-1 text-wrap">{gasto.amount}</span>
          <hr />
          <p>{gasto.description}</p>
        </p>
        {usuario ? (
          <>
            {autenticado && usuario.username === gasto.username ? (
              <div className="btn-group d-flex flex-wrap  ">
                <button
                  data-toggle="modal"
                  data-target={`#exampleModal`}
                  className="btn btn-outline-light btn-sm m-1 w-100"
                  onClick={() => seleccionarGasto(gasto)}
                >
                  Editar
                </button>
                <button
                  className="btn btn-outline-light  btn-sm  m-1 w-100"
                  onClick={onClickEliminar}
                >
                  Eliminar
                </button>
              </div>
            ) : null}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default CardGasto;
